import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './styles/styles.scss';
import { Product } from '@utils/product';
import { promotionClickGoogleTag } from '@utils/analytics';
import Link from '../base_link/component';
import { ProductImage } from 'audamatic-ui';

/**
 * Bookskyline component aka product gallery
 *
 *
 * It shows 4 books in and has a title,
 * you can click on the entire component.
 * It uses the default product data model.
 * @todo: promo data-promo for tagmanager in the anchor tag
 */
class Bookskyline extends Component {
  constructor(props) {
    super(props);
    this.shadowEffect = props['image-shadow'] !== undefined ? props['image-shadow'] : true;
    this.pushGoogleTags = this.pushGoogleTags.bind(this);
  }

  get products() {
    return (this.props.products || []).slice(0, 4);
  }

  getBooks() {
    return (
      <div className="wrapper">
        {this.products.map((product, i) => {
          const _product = new Product(product);
          return (
            <div className="item" key={i}>
              <ProductImage product={_product} maxHeight={149} />
            </div>
          );
        })
        }
      </div>
    );
  }

  get promotionTagData() {
    const { title, productSelection } = this.props;
    return {
      title,
      name: 'Product gallery',
      creative: productSelection,
      'component-type': this.props['component-type'],
      variant: 'gallery',
      url: this.url,
    };
  }

  pushGoogleTags() {
    this.props.store.pushToDataLayer(promotionClickGoogleTag(this.promotionTagData));
  }

  render() {
    const { title, url } = this.props;
    return (
      <Link className="book-skyline" href={url} onClick={this.pushGoogleTags}>
        <div className="product-gallery">
          {this.getBooks()}
        </div>
        {title && (
          <p className="content text-border">{title}</p>
        )}
      </Link>
    );
  }
}

// proptypes
Bookskyline.propTypes = {
  /**
   * The index of the item.
   * You can identify the nth sibling of the generic section component.
   */
  index: PropTypes.number,
  /**
   * The name of the skyline
   */
  name: PropTypes.string,
  title: PropTypes.string,
  /**
   * The url where the skyline links to
   */
  url: PropTypes.string,
  /**
   * The array of items inside the skyline. While this is a single key-value in JSX props, it may be
   * seperated into 2 props in the DOM definition: "products" and "productSelection". Both have the
   * same shape, but "productSelection" entries are inserted before "products".
   */
  products: PropTypes.arrayOf(
    PropTypes.shape({
      images: PropTypes.shape({
        Image: PropTypes.string,
      }),
      name: PropTypes.string,
    }),
  ),
  productSelection: PropTypes.any,
  store: PropTypes.object,
  'image-shadow': PropTypes.bool,
  'component-type': PropTypes.any,
};


export default Bookskyline;
